const candidateIdFields = [
  'id',
  'courseId',
  'specializationId',
  'degreeId',
  'collectionId',
  'roleId',
  'itemId',
  'lessonId',
];

export const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

const sortObjectKeys = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(sortObjectKeys);
  }
  if (!isPlainObject(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.keys(value)
      .sort()
      .map((key) => [key, sortObjectKeys(value[key])])
  );
};

export const getCandidateKey = (id: unknown): string => {
  if (typeof id === 'string') {
    return id;
  }

  try {
    return JSON.stringify(sortObjectKeys(id)) ?? String(id);
  } catch {
    return String(id);
  }
};

export const getCandidatePlaceholderId = (id: unknown): string => {
  if (typeof id === 'string') return id;
  if (isPlainObject(id)) {
    if (typeof id.courseId === 'string' && typeof id.itemId === 'string') {
      return `${id.courseId}~${id.itemId}`;
    }
    const idField = candidateIdFields.find((field) => typeof id[field] === 'string');
    if (idField) return id[idField] as string;
  }
  return getCandidateKey(id);
};

export const getCandidateLabel = (id: unknown): string => {
  if (typeof id === 'string') {
    return id;
  }

  if (isPlainObject(id)) {
    const idField = candidateIdFields.find((field) => typeof id[field] === 'string');
    if (idField) {
      const candidateId = id[idField] as string;
      return candidateId;
    }
  }

  const label = getCandidateKey(id);
  return label.length > 40 ? `${label.slice(0, 39)}…` : label;
};
